<script lang="ts">
    import { _ } from 'svelte-i18n';
    import type { Job } from './Job';
    import IconAdd from '../../shared/Icons/IconAdd.svelte';
    import IconDoNotDisturbOn from '../../shared/Icons/IconDoNotDisturbOn.svelte';
    import WarningColor from '../../shared/WarningColor.svelte';
    import InfoColor from '../../shared/InfoColor.svelte';
    import { debug } from '../../../stores/store';
    import { getJobColor } from './getJobColor';
    import JobTypeIcon from './JobTypeIcon.svelte';
    import DisplayAddressText from '../Planning/PageDeliveries2/DisplayAddressText.svelte';
    import DisplayJobDescriptionText from '../Planning/PageDeliveries2/DisplayJobDescriptionText.svelte';
    import DisplayLabel from './DisplayLabel.svelte';
    import { app } from '../../../stores/app';
    import { features } from '../../shared/Features/features';
    import { Liquid } from 'liquidjs';
    import { clientSettings } from '../../../stores/api';

    export let job: Job;
    export let simpleView = false;

    // console.log('DisplayAddress', job);

    let city = job.getGeocodedCity() || job.getCity() || '';
    let street = job.getGeocodedStreet() || job.getStreet() || '';
    let house = job.getGeocodedHouse() || job.getHouse() || '';
    let delivery_or_collection =
        job.getData()?.special_attributes?.delivery_or_collection || 'delivery';
    let newly_added = job.getData()?.newly_added;
    let rejected = job.getData()?.rejected;

    let coords_set_manually = job.getData()?.coords_set_manually || false;
    let show_coords = coords_set_manually && city === '' && street === '';

    let x = typeof job.getX() === 'number' ? formatGPSCoordinate('x', job.getX() || 0) : null;
    let y = typeof job.getY() === 'number' ? formatGPSCoordinate('y', job.getY() || 0) : null;

    let label = job.getLabel();

    let text = '';
    let subtext = '';

    if ($features.feature_configurable_job_description) {
        let jobData = Object.assign(JSON.parse(JSON.stringify(job.getData())), {
            coords: typeof x === 'string' && typeof y === 'string' ? y + ', ' + x : '',
        });
        let jobDescriptionTemplates = $app.account.getSettingsReadonly().job_description;
        let liquidEngine = new Liquid();
        label = liquidEngine.parseAndRenderSync(jobDescriptionTemplates.label, jobData);
        text = liquidEngine.parseAndRenderSync(jobDescriptionTemplates.text, jobData);
        subtext = liquidEngine.parseAndRenderSync(jobDescriptionTemplates.subtext, jobData);
    }

    function formatGPSCoordinate(type: string, value: number) {
        let cdeg = '';
        let deg = value;
        let sign = deg < 0 ? -1 : 1;
        deg = Math.abs(deg);
        let gpsdeg = Math.floor(deg);
        let remainder = deg - gpsdeg * 1;
        let gpsmin = remainder * 60;
        remainder = gpsmin - Math.floor(gpsmin) * 1;
        let gpssec = remainder * 60;
        cdeg =
            gpsdeg +
            '°' +
            Math.floor(gpsmin) +
            "'" +
            Math.round((10 * Math.floor(gpssec * 100)) / 100) / 10 +
            '"' +
            (sign > 0 ? (type == 'x' ? 'E' : 'N') : type == 'x' ? 'W' : 'S');
        return cdeg;
    }

    $: {
        rejected = job.getData()?.rejected;
        if (!$features.feature_configurable_job_description) {
            label = job.getLabel();
        }
    }
</script>

{#if simpleView}
    <JobTypeIcon
        type={delivery_or_collection}
        scale={0.6}
        color={getJobColor(job.getData(), null, $clientSettings.display.selected_job_color_method)}
    />
    <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
        {#if $features.feature_configurable_job_description}
            <DisplayJobDescriptionText label={label || ''} {text} {subtext} flexColumn={false} />
        {:else}
            <DisplayAddressText {city} {street} {house} {x} {y} label={null} flexColumn={false} />
        {/if}
    </div>
    <div
        style="display: flex; margin-left: auto;column-gap: 3px; margin-right: 3px; flex: 0 1 auto; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; "
    >
        <!--{#if job.ad_hoc}-->
        <!--    <IconFlashOn scale={0.5} title={$_('Ad-hoc')} />-->
        <!--{/if}-->
        {#if !$features.feature_configurable_job_description}
            <div
                style="flex: 0 1 auto; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; "
            >
                <DisplayLabel {label} />
            </div>
        {/if}
        {#if newly_added || $debug}
            <InfoColor>
                <IconAdd scale={0.5} title={$_('Newly added')} />
            </InfoColor>
        {/if}
        {#if rejected || $debug}
            <WarningColor>
                <IconDoNotDisturbOn scale={0.5} title={$_('Rejected')} />
            </WarningColor>
        {/if}
    </div>
{:else}
    <div>
        <JobTypeIcon
            type={delivery_or_collection}
            scale={0.6}
            color={getJobColor(
                job.getData(),
                null,
                $clientSettings.display.selected_job_color_method
            )}
        />
    </div>
    <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
        {#if $features.feature_configurable_job_description}
            <DisplayJobDescriptionText label={label || ''} {text} {subtext} flexColumn={true} />
        {:else}
            <DisplayAddressText {city} {street} {house} {x} {y} {label} flexColumn={true} />
        {/if}
    </div>
    <div style="display: flex; margin-left: auto;column-gap: 3px;">
        {#if newly_added || $debug}
            <InfoColor>
                <IconAdd scale={0.5} title={$_('Newly added')} />
            </InfoColor>
        {/if}
        {#if rejected || $debug}
            <WarningColor>
                <IconDoNotDisturbOn scale={0.5} title={$_('Rejected')} />
            </WarningColor>
        {/if}
    </div>
{/if}
